import React from 'react';

import { ProductsList } from 'components/ProductLists';

const DetailLayout = () => <ProductsList />;

export default DetailLayout;
